export default __webpack_public_path__ + "static/media/kidney_bean.5b8a365d.jpeg";